module.exports = __webpack_public_path__ + "img/701252ulpgc.fdabf00e.jpg";